import React from "react";

export const lightbulbIcon = <svg version="1.1" x="0px" y="0px" viewBox="0 0 1200 1200">
  <g transform="translate(0.000000,1200.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
    <path d="M5783 11560 c-712 -53 -1385 -317 -1948 -766 -141 -113 -426 -398
      -539 -539 -286 -359 -508 -784 -631 -1205 -187 -645 -188 -1318 -5 -1959 134
      -466 350 -874 675 -1276 220 -272 342 -531 510 -1080 144 -469 443 -749 903
      -842 76 -16 147 -18 552 -18 l465 0 87 31 c300 107 650 497 1243 1384 211 315
      288 446 410 695 343 700 460 1210 374 1638 -87 436 -381 741 -817 849 -120 30
      -347 32 -442 4 -152 -44 -370 -168 -508 -290 -35 -31 -66 -56 -69 -56 -3 0
      -43 36 -89 79 -148 143 -265 218 -424 272 -90 31 -103 33 -235 33 -540 -1
      -969 -332 -1100 -847 -107 -422 -1 -935 294 -1421 160 -265 407 -576 680 -859
      119 -123 172 -152 281 -151 126 0 214 55 270 166 26 52 30 72 30 137 0 109
      -24 153 -159 296 -560 590 -824 1064 -824 1485 0 133 15 204 63 306 83 174
      254 274 465 274 142 -1 253 -64 390 -222 40 -45 41 -47 28 -83 -29 -83 -45
      -209 -41 -320 3 -98 7 -117 34 -175 86 -181 269 -276 409 -211 97 45 189 161
      227 285 18 59 20 84 15 175 -4 58 -15 142 -26 186 l-19 79 62 61 c111 109 278
      197 400 211 122 14 277 -38 370 -126 106 -100 150 -224 149 -420 0 -283 -108
      -621 -359 -1122 -255 -510 -577 -970 -1035 -1479 -202 -225 -240 -248 -414
      -256 -167 -8 -633 13 -688 31 -179 58 -296 184 -360 391 -90 288 -124 391
      -157 475 -140 351 -276 589 -490 855 -412 512 -627 1087 -647 1735 -15 478 82
      932 288 1355 370 759 1070 1331 1879 1535 283 72 502 95 804 87 439 -12 804
      -102 1201 -297 634 -311 1135 -854 1401 -1516 97 -242 159 -489 190 -760 20
      -171 14 -570 -10 -734 -91 -603 -320 -1139 -666 -1555 -292 -351 -490 -748
      -613 -1230 -80 -315 -114 -577 -129 -1005 -3 -59 -9 -88 -32 -135 -129 -264
      -651 -476 -1416 -575 -305 -39 -798 -70 -1137 -70 -148 0 -209 -19 -275 -83
      -141 -137 -124 -367 36 -476 81 -56 111 -59 686 -65 551 -5 758 -14 1080 -46
      495 -49 772 -136 870 -272 34 -47 37 -65 12 -94 -84 -102 -373 -165 -882 -194
      -102 -6 -518 -13 -925 -16 l-740 -4 -63 -31 c-230 -112 -227 -437 6 -551 l67
      -33 555 -7 c666 -7 909 -25 1200 -84 402 -83 662 -241 860 -522 70 -100 152
      -145 265 -146 128 0 242 76 286 192 27 74 23 186 -9 249 -62 120 -296 381
      -424 473 -27 18 -48 36 -47 39 0 3 32 22 70 41 91 45 213 142 266 211 134 175
      182 343 150 531 -18 103 -68 227 -128 314 -79 116 -233 235 -401 313 l-83 38
      81 41 c277 139 495 345 600 567 68 142 83 223 94 495 17 437 79 757 210 1089
      101 257 213 448 381 649 456 550 733 1224 820 1992 17 150 18 601 1 745 -20
      169 -49 326 -87 482 -352 1415 -1555 2472 -3005 2638 -170 19 -488 26 -647 15z
      m197 -3504 c0 -2 -8 -10 -17 -17 -16 -13 -17 -12 -4 4 13 16 21 21 21 13z"
    />
  </g>
</svg>
